<template>
  <view class="banner">
    <swiper class="swiper" :indicator-dots="false" :circular="true" >
      <swiper-item v-for="item in dataList" :key="item.index">
        <div class="card">
			<image class="pic" lazy-load :src="item.imageUrl" mode="aspectFill" />
			<div class="txt">
			  {{ item.name }}
			</div>
			<div class="footer">
			  <div class="label">
				标签
			  </div>
			  <div class="number">
				浏览量 999
			  </div>
			</div>
		  </div>
      </swiper-item>
    </swiper>
  </view>
</template>
<script>
export default {
  name: "vanTwoSlide",
  data() {
    return {
      
    };
  },
  props: {
      dataList: {
        type: Array,
        default () {
          return []
        }
      }
    }
};
</script>
<style lang="less" scoped>
	.swiper{
		height:240px;
	}
.banner{
	overflow: hidden;
	padding: 10px 0 0 10px;
  /deep/swiper-item{width:250px !important;}
}
.card {
  overflow: hidden;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  width: 235px;
  padding-bottom: 10px;
  margin-right: 10px;
  margin-left:10px;
  .pic{
    width: 235px;
    height: 135px;
  }
  .txt {
    padding: 6px 10px 0 10px;
    color: #333;
    font-size: 15px;
    height: 40px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    margin-top: 10px;
    height: 20px;
    .label {
      color: #ff740b;
      border-radius: 4px;
      background: none;
      border: 1px #ff740b solid;
      // padding: 2px 6px;
      padding: 0 4px;
      line-height: 20px;
      height: 20px;
      font-size: 11px;
    }
    .number {
      color: #999;
      font-size: 12px;
      line-height: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
  }
}
</style>
